import React from 'react';
import { interpolate, Easing } from 'remotion';
import { TransitionInEffect } from '@goldcast/player-config/src/types/transitions';

export function getTransitionWordInStyles({
  fps,
  frame,
  startFrame,
  animationType
}: {
  fps: number;
  frame: number;
  startFrame: number;
  animationType: TransitionInEffect;
}): React.CSSProperties {
  const isVisible = frame >= startFrame;
  const framesSinceStart = Math.max(0, frame - startFrame);

  switch (animationType) {
    case TransitionInEffect.None:
    default:
      return {
        visibility: isVisible ? 'visible' : 'hidden'
      };

    case TransitionInEffect.Fade: {
      if (!isVisible) {
        return { opacity: 0 };
      }
      const animationDurationSeconds = 0.15;
      const animationDuration = Math.ceil(animationDurationSeconds * fps);
      const progress = interpolate(framesSinceStart, [0, animationDuration], [0, 1], {
        easing: Easing.out(Easing.ease),
        extrapolateLeft: 'clamp',
        extrapolateRight: 'clamp'
      });
      return {
        opacity: progress
      };
    }

    case TransitionInEffect.SlideUp: {
      if (!isVisible) {
        return { opacity: 0, transform: 'translateY(6px)' };
      }
      const animationDurationSeconds = 0.15;
      const animationDuration = Math.ceil(animationDurationSeconds * fps);
      const slideDistance = 6;
      const progress = interpolate(framesSinceStart, [0, animationDuration], [0, 1], {
        easing: Easing.out(Easing.ease),
        extrapolateLeft: 'clamp',
        extrapolateRight: 'clamp'
      });
      const yOffset = slideDistance * (1 - progress);
      return {
        transform: `translateY(${yOffset}px)`,
        opacity: progress
      };
    }

    case TransitionInEffect.Spring: {
      if (!isVisible) {
        return { opacity: 0, transform: 'scale(0.8)' };
      }
      const animationDurationSeconds = 0.2;
      const animationDuration = Math.ceil(animationDurationSeconds * fps);
      const startScale = 0.8;
      const endScale = 1.0;
      const progress = interpolate(framesSinceStart, [0, animationDuration], [0, 1], {
        easing: Easing.elastic(1.2),
        extrapolateLeft: 'clamp',
        extrapolateRight: 'clamp'
      });
      const scale = startScale + (endScale - startScale) * progress;
      return {
        transform: `scale(${scale})`,
        opacity: progress
      };
    }

    case TransitionInEffect.Appear: {
      if (!isVisible) {
        return { opacity: 0 };
      }

      return { opacity: 1 };
    }
  }
}
